import { Injectable } from '@angular/core';
import { Http,Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class LoginService {

  constructor(public _http: Http) { }
  private _contactUrl = 'http://imssacv.com.mx/api/index.php/main/loginClient';
  private _contactUrla = 'http://imssacv.com.mx/api/index.php/main/loginAdmin';
    sendLogin(value:any){
        
  		const body = new URLSearchParams(value);
  		body.set('username', value.data[0].username);
  		body.set('password', value.data[0].password);
  		let headers = new Headers();
  		headers.append('Content-Type','application/x-www-form-urlencoded');
  		return this._http.post(this._contactUrl, body, {
  			 headers : headers
  		}).map( res => res.json() );

  	}
    getUserData(){
       return this._http.get('http://imssacv.com.mx/api/index.php/main/userdata',{headers : new Headers({ 'Authorization':localStorage.getItem('userToken')  })  
        }).map( res => res.json() );
    }
    checkAuth(){
       return this._http.get('http://imssacv.com.mx/api/index.php/main/checkAuth',{headers : new Headers({ 'Authorization':localStorage.getItem('userToken')  })  
        }).map( res => res.json() );
    }
    checkClientAuth(){
       return this._http.get('http://imssacv.com.mx/api/index.php/main/checkAuth',{headers : new Headers({ 'Authorization':localStorage.getItem('clientToken')  })  
        }).map( res => res.json() );
    }
    sendLoginAdmin(value:any){
        
      const body = new URLSearchParams(value);
      body.set('username', value.data[0].username);
      body.set('password', value.data[0].password);
      let headers = new Headers();
      headers.append('Content-Type','application/x-www-form-urlencoded');
      return this._http.post(this._contactUrla, body, {
         headers : headers
      }).map( res => res.json() );

    }
  }


// WEBPACK FOOTER //
// ./src/app/_service/login.service.ts